@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-list-layout-boxes-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.formContext"
                [listLayout]="_context.formContext.item"
                (listLayoutUpdated)="onListLayoutUpdated($event)"
                (canceled)="onCanceled($event)"></app-list-layout-boxes-form>
        </mat-tab>
        @if (!!_context.formContext.item.id) {
            <mat-tab label="Colonnes">
                <app-list-layout-boxes-columns-form
                    [context]="_context.formContext"
                    (listLayoutUpdated)="onListLayoutUpdated($event)"
                    [sizeInPercent]="_context.formContext.item.isScreenSizeAdapted"
                    [sortEnabled]="true"
                    (recordUpdated)="onListLayoutColumnsUpdated($event)"
                    (recordRefreshed)="onListLayoutColumnsRefreshed($event)"
                    (canceled)="onCanceled($event)"></app-list-layout-boxes-columns-form>
                @if (_context.formContext.item.isScreenSizeAdapted) {
                    <div class="footer-container">
                        @if (totalColumnSize !== 100) {
                            <span><fa-icon [icon]="warningIcon" class="warning-icon"></fa-icon></span>
                            @if (totalColumnSize > 100) {
                                <span class="warning-text">Attention, la taille dépasse la largeur de la liste, certaines colonnes ne seront pas visibles.</span>
                            } @else {
                                <span class="warning-text">Attention, la taille est inférieure à la largeur de la liste, de l'espace ne sera pas utilisé.</span>
                            }
                        }

                        <span class="sum-text">Somme de la taille des colonnes : {{ totalColumnSize }} %</span>
                    </div>
                }
            </mat-tab>
        }
        @if (!!_context.formContext.item.id) {
            <mat-tab label="Mise en page par défaut">
                <app-list-layout-boxes-accessibility-form
                    [listLayout]="_context.formContext.item"
                    [disabled]="_context.formMode === FormMode.Reading"
                    (accessibilitiesUpdated)="onAccessibilitiesUpdated($event)"
                    (canceled)="onCanceled($event)"></app-list-layout-boxes-accessibility-form>
            </mat-tab>
        }
    </mat-tab-group>
}
